/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
 */
export interface UpdateSlackEvidenceReminderPerChannelRequestSettingsInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveDayType': UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveDay': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveHours': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'notificationScope': UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum;
}

export const UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum = {
    number: 'NUMBER',
    endOfMonth: 'END_OF_MONTH'
} as const;

export type UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum = typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum[keyof typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum];
export const UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum = {
    thisMonth: 'THIS_MONTH',
    prevMonth: 'PREV_MONTH'
} as const;

export type UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum = typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum[keyof typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum];


